import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import storage from "components/Pixacom/storage";

export const getTasks = (filter) => {
  return async (dispatch, getState) => {
    await axios
      .get("/api/task/" + filter, {
        headers: { Authorization: `Bearer ${storage.getItem("token")}` },
      })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          const params = { ...getState().todoApp.params, filter: filter };
          dispatch({
            type: "GET_TASKS",
            tasks: response.data,
            filteredTasks: sortTasks(
              filterTasks(response.data, filter),
              params.sort
            ),
            params,
          });
        }

        dispatch({ type: "LOADING", loading: false });
      })
      .catch((err) => dispatch({ type: "LOADING", loading: false }));
  };
};

export const getTasksAll = (filter, admin = false) => {
  return async (dispatch, getState) => {
    if (admin) {
      await axios
        .get("/api/task/allAdmin", {
          headers: { Authorization: `Bearer ${storage.getItem("token")}` },
        })
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            const params = { ...getState().todoApp.params, filter: filter };
            dispatch({
              type: "GET_TASKS",
              tasks: response.data,
              filteredTasks: sortTasks(
                filterTasks(response.data, filter),
                params.sort
              ),
              params,
            });
          }

          dispatch({ type: "LOADING", loading: false });
        })
        .catch((err) => dispatch({ type: "LOADING", loading: false }));
    } else {
      await axios
        .get("/api/task/all", {
          headers: { Authorization: `Bearer ${storage.getItem("token")}` },
        })
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            const params = { ...getState().todoApp.params, filter: filter };
            dispatch({
              type: "GET_TASKS",
              tasks: response.data,
              filteredTasks: sortTasks(
                filterTasks(response.data, filter),
                params.sort
              ),
              params,
            });
          }

          dispatch({ type: "LOADING", loading: false });
        })
        .catch((err) => dispatch({ type: "LOADING", loading: false }));
    }
  };
};

export const loading = (load) => {
  return (dispatch) => {
    dispatch({ type: "LOADING", loading: load });
  };
};

const updateTasksLoad = async (index, item, tasks, config) => {
  if (index >= 0) tasks.splice(index, 1);
  var response = await axios.get("/api/task/structured/" + item, config);
  if (response.status >= 200 && response.status <= 299) {
    if (index >= 0) tasks.splice(index, 0, response.data);
    else tasks.push(response.data);
  }
  return tasks;
};

export const updateTasks = (item, action) => {
  return async (dispatch, getState) => {
    let config = {
      headers: { Authorization: `Bearer ${storage.getItem("token")}` },
    };
    let tasks = getState().todoApp.tasks;
    let index = -1;

    switch (action) {
      case "complete":
      case "uncomplete":
        await axios.put("/api/task/" + action + "d/" + item, null, config);
        index = tasks.findIndex((step) => {
          return step.task.id === item;
        });
        tasks = await updateTasksLoad(index, item, tasks, config);
        break;
      case "delete":
        await axios.put("/api/task/trash/" + item, null, config);
        index = tasks.findIndex((step) => {
          return step.task.id === item;
        });
        tasks = await updateTasksLoad(index, item, tasks, config);
        break;
      case "untrash":
        await axios.put("/api/task/untrash/" + item, null, config);
        index = tasks.findIndex((step) => {
          return step.task.id === item;
        });
        if (index >= 0) tasks.splice(index, 1);
        await axios
          .get("/api/task/structured/" + item, config)
          .then((response) => {
            if (response.status >= 200 && response.status <= 299) {
              if (index >= 0) tasks.splice(index, 0, response.data);
              else tasks.push(response.data);
            }
          });
        break;
      case "update":
        index = tasks.findIndex((step) => {
          return step.task.id === item;
        });
        if (index >= 0) tasks.splice(index, 1);
        await axios
          .get("/api/task/structured/" + item, config)
          .then((response) => {
            if (response.status >= 200 && response.status <= 299) {
              if (index >= 0) tasks.splice(index, 0, response.data);
              else tasks.push(response.data);
            }
          });
        break;
      case "add":
      default:
        await axios
          .get("/api/task/structured/" + item, config)
          .then((response) => {
            if (response.status >= 200 && response.status <= 299) {
              if (index >= 0) tasks.splice(index, 0, response.data);
              else tasks.push(response.data);
            }
          });
        break;
    }

    const params = { ...getState().todoApp.params };
    dispatch({
      type: "GET_TASKS",
      tasks: tasks,
      filteredTasks: sortTasks(filterTasks(tasks, params.filter), params.sort),
      params,
    });
  };
};

const titleSort = (a, b) => {
  if (a.task.subject < b.task.subject) return -1;
  if (a.task.subject > b.task.subject) return 1;
  return 0;
};

/*
  const assignee = (a, b) => {
    if (a.assignee < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  }
  
  const dueDate = (a, b) => {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  }
  */
const sortAlgorythm = (sort, a, b) => {
  switch (sort) {
    case "title-asc":
      return titleSort(a, b);
    case "title-desc":
      return titleSort(b, a);
    default:
      return 0;
  }
};

export const sorting = (sort) => {
  return (dispatch, getState) => {
    const params = { ...getState().todoApp.params, sort: sort };
    const tasks = getState().todoApp.tasks.sort((a, b) => {
      return sortAlgorythm(sort, a, b);
    });

    dispatch({ type: "SORT", tasks, params });
  };
};

export const filtering = (filter) => {
  return (dispatch, getState) => {
    const params = { ...getState().todoApp.params, filter: filter };
    let tasks = filterTasks(getState().todoApp.tasks, filter);
    dispatch({ type: "FILTERING", filteredTasks: tasks, params });
  };
};

const filterTasks = (tasks, filter) => {
  switch (filter) {
    case "inbox":
      tasks = tasks.filter((item) => {
        return (
          item.task.end === null &&
          item.task.begin === null &&
          !item.task.trashed
        );
      });
      break;
    case "today":
      tasks = tasks.filter((item) => {
        return (
          (item.task.begin !== null || item.task.end !== null) &&
          (item.task.begin === null ||
            moment(item.task.begin).isBefore(new Date(), "day") ||
            moment(item.task.begin).isSame(new Date(), "day")) &&
          (item.task.end === null ||
            moment(item.task.end).isAfter(new Date(), "day") ||
            moment(item.task.end).isSame(new Date(), "day")) &&
          !item.task.trashed
        );
      });
      break;
    case "coming":
      //const dateWeek = new Date();
      //dateWeek.setDate(dateWeek.getDate() + 7);
      tasks = tasks.filter((item) => {
        return !item.task.trashed;
      }); //tasks.filter((item) => { return item.task.end !== null && moment(item.task.end).isBefore(dateWeek, "day") && !moment(item.task.end).isSame(new Date(), "day") && !item.task.trashed })
      break;
    case "completed":
      tasks = tasks.filter((item) => {
        return item.task.completed && !item.task.trashed;
      });
      break;
    case "deleted":
      tasks = tasks.filter((item) => {
        return item.task.trashed;
      });
      break;
    default:
      tasks = tasks.filter((item) => {
        return !item.task.trashed;
      });
      break;
  }
  return tasks;
};
const sortTasks = (tasks, sort) => {
  return tasks.sort((a, b) => {
    return sortAlgorythm(sort, a, b);
  });
};

export const searching = (query, data) => {
  return (dispatch, getState) => {
    const params = { ...getState().todoApp.params, query: query };
    let tasks = filterTasks(data, params.filter);
    dispatch({ type: "SEARCHING", filteredTasks: tasks, params });
  };
};

export const tags = (tag) => {
  return (dispatch, getState) => {
    const params = { ...getState().todoApp.params, tag: tag };

    dispatch({ type: "TAGS", params });
  };
};

export const trash = (id) => {
  updateTasks(id, "delete");
  /*var token = storage.getItem('token');
  var config = { headers: { Authorization: `Bearer ${token}` } }
  
  return async (dispatch, getState) => {
    const params = getState().todoApp.params;
    let tasks = getState().todoApp.tasks.filter(item => item.task.id !== id);
    let task = getState().todoApp.tasks.filter(item => item.task.id === id);
    if (task.length > 0) {
      task[0].task.deleted = true;
      tasks.push(task[0]);
      let response = await axios.put("/api/Task/Trash/" + id, null, config);

      //Promise.all([
      //dispatch({ type: "TRASH", tasks})
      
      //])
      }
      applyParams();
    }*/
};

/*export const untrash = id => {
  var token = storage.getItem('token');
  var config = { headers: { Authorization: `Bearer ${token}` } }
  return (dispatch, getState) => {
    const params = getState().todoApp.todo.routeParam
    axios
      .put("/api/Task/Untrash/" + id, null, config)
      .then(response => {
        dispatch({ type: "UNTRASH", id})
        dispatch(getTodos(params))})
      .catch(e => toast.error("Chyba při vkládání dat na server!"))
  }
}*/

const applyParams = () => {
  return (dispatch, getState) => {
    const params = getState().todoApp.params;
    sorting(params.sort);
    filtering(params.filtering);
  };
};
